export const name = 'Toggle Chart';

export const CHART_CLASS_NAME = '.surf-wind-chart';
export const PERIODS_CLASS_NAME = '.surf-wind-periods';
export const PERIODS_SELECT_CLASS_NAME = '.surf-wind-periods-select';
export const CHART_THUMBNAIL_CLASS_NAME = '.surf-wind-chart-thumbnail';

export function getChartBlock(parent) {
  return parent.querySelector(CHART_CLASS_NAME);
}

export function getChartImage(parent) {
  return parent.querySelector(`${CHART_CLASS_NAME}__image--js`);
}

export function getChartWaves(parent) {
  return parent.querySelector(`${CHART_CLASS_NAME}__waves--js`);
}

export function getChartLabel(parent) {
  return parent.querySelector(`${CHART_CLASS_NAME}__label--js`);
}

export function getPeriodsSelectBlocks(parent) {
  return parent.querySelectorAll(PERIODS_SELECT_CLASS_NAME);
}

export function getPeriodsSelect(parent) {
  return parent.querySelector(`${PERIODS_SELECT_CLASS_NAME}__select--js`);
}

export function getThumbnailsBlocks(parent) {
  return parent.querySelectorAll(CHART_THUMBNAIL_CLASS_NAME);
}

export function getThumbnailsBlockLink(parent) {
  return parent.querySelector(`${CHART_THUMBNAIL_CLASS_NAME}__container--js`);
}

export function getPeriodsBlocks(parent) {
  return parent.querySelectorAll(PERIODS_CLASS_NAME);
}

export function getPeriodsBlockLinks(parent) {
  return parent.querySelectorAll(`${PERIODS_CLASS_NAME}__link--js`);
}

export function updateChart(chartBlock, newType, newSrc) {
  const chartImage = getChartImage(chartBlock);
  chartImage.src = newSrc;

  const currentType = chartBlock.dataset.type;
  if (currentType === newType) return;

  /* eslint-disable-next-line no-param-reassign */
  chartBlock.dataset.type = newType;

  const chartWaves = getChartWaves(chartBlock);
  const chartLabel = getChartLabel(chartBlock);

  const chartWavesClassName = `${CHART_CLASS_NAME.slice(1)}__waves`;
  chartWaves.classList.add(`${chartWavesClassName}--${newType}`);
  chartWaves.classList.remove(`${chartWavesClassName}--${currentType}`);

  const chartLabelClassName = `${CHART_CLASS_NAME.slice(1)}__label`;
  chartLabel.classList.add(`${chartLabelClassName}--${newType}`);
  chartLabel.classList.remove(`${chartLabelClassName}--${currentType}`);
}

export const ACTIVE_CLASS_NAME = 'is-active';

export function toggleActiveClassName(elements, action) {
  elements.forEach(el => {
    el.classList[action](ACTIVE_CLASS_NAME);
  });
}

export function updateThumbnails(thumbs, newType, activeMonthName) {
  const needsToBeActivated = thumbs.filter(
    th =>
      th.dataset.monthName === activeMonthName && th.dataset.type === newType
  );

  toggleActiveClassName(thumbs, 'remove');
  toggleActiveClassName(needsToBeActivated, 'add');
}

export function updatePeriodsSelects(
  periodsSelectBlocks,
  newType,
  activeMonthName
) {
  periodsSelectBlocks.forEach(selectBlock => {
    const select = getPeriodsSelect(selectBlock);
    const options = Array.from(select.options);
    const needsToBeSelected = options.filter(
      opt => opt.label === activeMonthName && select.name === newType
    );
    options.forEach(opt => {
      /* eslint-disable-next-line no-param-reassign */
      opt.selected = false;
    });

    needsToBeSelected.forEach(opt => {
      /* eslint-disable-next-line no-param-reassign */
      opt.selected = true;
    });
  });
}

export function updatePeriods(periodsBlocks, newType, activeMonthName) {
  periodsBlocks.forEach(periodBlock => {
    const links = Array.from(getPeriodsBlockLinks(periodBlock));
    const needsToBeActivated = links.filter(
      l =>
        periodBlock.dataset.type === newType &&
        l.dataset.monthName === activeMonthName
    );

    toggleActiveClassName(links, 'remove');
    toggleActiveClassName(needsToBeActivated, 'add');
  });
}

export function updateDOMState(
  chartBlock,
  thumbsBlocks,
  periodsBlocks,
  periodsSelectBlocks
) {
  return function update(newType, newSrc, activeMonthName) {
    updateChart(chartBlock, newType, newSrc);
    updatePeriods(periodsBlocks, newType, activeMonthName);
    updatePeriodsSelects(periodsSelectBlocks, newType, activeMonthName);
    updateThumbnails(thumbsBlocks, newType, activeMonthName);
  };
}

export function listenThumbClick(thumb, link, updateState) {
  link.addEventListener('click', event => {
    event.preventDefault();

    const { href: newSrc } = link;
    const { type: newType, monthName: activeMonthName } = thumb.dataset;

    updateState(newType, newSrc, activeMonthName);
  });
}

export function listenSelectChange(select, updateState) {
  select.addEventListener('change', () => {
    const { name: newType, value: newSrc, selectedOptions } = select;
    const { label: activeMonthName } = selectedOptions[0];

    updateState(newType, newSrc, activeMonthName);
  });
}

export function listenPeriodsClick(periodsBlock, link, updateState) {
  link.addEventListener('click', event => {
    event.preventDefault();

    const { href: newSrc } = link;
    const { type: newType } = periodsBlock.dataset;
    const { monthName: activeMonthName } = link.dataset;

    updateState(newType, newSrc, activeMonthName);
  });
}

export default function HOF(block) {
  const chartBlock = getChartBlock(block);
  const periodsBlocks = Array.from(getPeriodsBlocks(block));
  const thumbsBlocks = Array.from(getThumbnailsBlocks(block));
  const periodsSelectBlocks = Array.from(getPeriodsSelectBlocks(block));

  const updateState = updateDOMState(
    chartBlock,
    thumbsBlocks,
    periodsBlocks,
    periodsSelectBlocks
  );

  thumbsBlocks.forEach(thumb => {
    const thumbLink = getThumbnailsBlockLink(thumb);
    listenThumbClick(thumb, thumbLink, updateState);
  });

  periodsSelectBlocks.forEach(selectBlock => {
    const select = getPeriodsSelect(selectBlock);
    listenSelectChange(select, updateState);
  });

  periodsBlocks.forEach(periodsBlock => {
    const periodsBlockLink = Array.from(getPeriodsBlockLinks(periodsBlock));
    periodsBlockLink.forEach(link => {
      listenPeriodsClick(periodsBlock, link, updateState);
    });
  });
}
